import { CardBody } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { teamShotMarkersAtom, unwrappedTeamShotMarkersAtom } from '@/atoms/queries/team/teamEventData';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { ErrorCard } from '@/components/contentState/ErrorCard';
import { ShotMap } from '@/components/visualisations/ShotMap/ShotMap';
import { useLoadableStatus } from '@/hooks/useLoadableStatus';
import { useStatus } from '@/hooks/useStatus';

const TeamShotMapWithData = () => {
  const unwrappedTeamShotMarkers = useAtomValue(unwrappedTeamShotMarkersAtom);
  const status = useLoadableStatus(teamShotMarkersAtom);
  const statusProps = useStatus('general', status);

  return (
    <CardHeightWrapper>
      <CardBody {...statusProps}>
        <ShotMap events={unwrappedTeamShotMarkers} />
      </CardBody>
    </CardHeightWrapper>
  );
};

export const TeamShotMap = () => (
  <ErrorCard translationNameSpace="general" fallbackChildren={<ShotMap events={[]} />}>
    <TeamShotMapWithData />
  </ErrorCard>
);
